import { Skeleton } from 'antd'

import styles from './StoryMapCardDetailModal.module.css'

const StoryMapCardDetailSkeleton = ({ cardType }) => {
    return (
        <div
            className={styles.skeletonRoot}
            aria-busy="true"
            aria-label="Loading card details"
        >
            <div className={styles.contentScroll}>
                <div className={styles.titleSection}>
                    <div className={styles.titleRow}>
                        <Skeleton.Input active className={styles.skTitle} />
                        {cardType === 'story' ? (
                            <Skeleton.Button active className={styles.skStatus} />
                        ) : null}
                    </div>
                    <div className={styles.skContextRow}>
                        <span className={`${styles.skPulse} ${styles.skCrumb}`} />
                        {cardType === 'story' ? (
                            <>
                                <span
                                    className={`${styles.skPulse} ${styles.skCrumbShort}`}
                                />
                                <span
                                    className={`${styles.skPulse} ${styles.skCrumbShort}`}
                                />
                            </>
                        ) : null}
                    </div>
                </div>

                <div className={`${styles.scrollBody} ${styles.scrollBodyLoading}`}>
                    <section className={styles.section}>
                        <div className={styles.skAttachmentsPanel}>
                            <Skeleton.Input active size="small" className={styles.skLabel} />
                            <Skeleton.Node active className={styles.skAttachmentUpload}>
                                <div />
                            </Skeleton.Node>
                        </div>
                    </section>

                    <section className={styles.section}>
                        <Skeleton.Input active size="small" className={styles.skLabel} />
                        <Skeleton.Node active className={styles.skDescription}>
                            <div />
                        </Skeleton.Node>
                    </section>
                </div>
            </div>

            <div className={styles.commentsFooter}>
                <div className={styles.skFooterTabs}>
                    <Skeleton.Input active size="small" className={styles.skFooterTab} />
                    <Skeleton.Input active size="small" className={styles.skFooterTab} />
                </div>
                <div className={styles.commentInputFooter}>
                    <Skeleton.Node active className={styles.skCommentInput}>
                        <div />
                    </Skeleton.Node>
                </div>
            </div>
        </div>
    )
}

export default StoryMapCardDetailSkeleton
